export { MdInfo as IconInfo } from "react-icons/md";
